import { useState, useCallback } from 'react';

const useToggle = (initialValue = false) => {
    const [state, setState] = useState(initialValue);

    const toggle = useCallback(() => {
        setState(prevState => !prevState);
    }, []);

    const open = useCallback(() => {
        setState(true);
    }, []);

    const close = useCallback(() => {
        setState(false);
    }, []);

    return { state, toggle, open, close };
};

export default useToggle;
